module.exports = __webpack_public_path__ + "img/refrigerator-icon.ed89bd1f.svg";